class EventBus {
    constructor() {
        this.listeners = new Map();
    }
    emit(event, ...args) {
        const eventListeners = this.listeners.get(event);
        if (eventListeners) {
            const payload = args[0];
            eventListeners.forEach(listener => {
                try {
                    listener(payload);
                }
                catch (error) {
                    console.error(`Error in event listener for ${event}:`, error);
                }
            });
        }
    }
    on(event, listener) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(listener);
        return () => {
            this.off(event, listener);
        };
    }
    off(event, listener) {
        var _a;
        (_a = this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.delete(listener);
    }
    once(event, listener) {
        const wrapper = ((payload) => {
            listener(payload);
            this.off(event, wrapper);
        });
        return this.on(event, wrapper);
    }
    removeAllListeners(event) {
        if (event) {
            this.listeners.delete(event);
        }
        else {
            this.listeners.clear();
        }
    }
    listenerCount(event) {
        var _a;
        return ((_a = this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.size) || 0;
    }
}
export const eventBus = new EventBus();
